import { useFormikContext } from 'formik';
import { Button, Card, Modal } from 'react-bootstrap';
import CardHeader from 'react-bootstrap/esm/CardHeader';
import logoZurichMoney from '../../../assets/zurich-bag-of-money-dollar.png';
import logoZurichDeath from '../../../assets/zurich-death.png';
import logoZurichFraud from '../../../assets/zurich-fraud.png';
import logoZurichDisaster from '../../../assets/zurich-rain-shower.png';
import { Insurance } from '../../../types/terminals/model';

interface ZurichModalProps {
  show: boolean;
  toggleModal: () => void;
  insurances: Insurance[];
}

const ZurichModal = ({ show, toggleModal, insurances }: ZurichModalProps) => {
  const { setFieldValue, values } = useFormikContext<any>();
  return (
    <Modal show={show} onHide={toggleModal} centered size="lg">
      <Card className="modal-card zurich-insurance-card" style={{border: 'none'}}>
        <CardHeader className="zurich-header">
          <h1 className="zurich-title">Protección para ingresos</h1>
          <p className="zurich-subtitle">
            Protege tus ingresos diarios en caso de que no puedas facturar por estas eventualidades
          </p>
        </CardHeader>

        <Card.Body className="zurich-body">
          <div className="zurich-content" style={{backgroundColor: '#FAFAFA', opacity: 1, borderWidth: '1px', borderRadius: '6px', borderStyle: 'dashed'}}>          
            {/* Disaster Damage Protection */}
            <div className="protection-item" style={{margin: '1.5rem'}}>
              <div className="protection-icon disaster-icon">
                <img
                  src={logoZurichDisaster}
                  alt="Daños ante desastres (Incendio, explosión, lluvias, etc)"
                />
              </div>
              <div className="protection-content">
                <h3 className="protection-title">Daños ante desastres (Incendio, explosión, lluvias, etc)</h3>
                <p className="protection-description">
                  Te pagamos hasta <strong>$40.000 al año</strong> por la pérdida de ingresos (máximo{' '}
                  <strong>5 diarias</strong>)*
                </p>
              </div>
            </div>

            {/* Death Protection */}
            <div className="protection-item" style={{margin: '1.5rem'}}>
              <div className="protection-icon death-icon">
                <img src={logoZurichDeath} alt="Fallecimiento de un socio y/o empleado" />
              </div>
              <div className="protection-content">
                <h3 className="protection-title">Fallecimiento de un socio y/o empleado</h3>
                <p className="protection-description">
                  Te pagamos hasta <strong>$24.000 al año</strong> por la pérdida de ingresos por cierre
                  (máximo <strong>3 diarias</strong>)*
                </p>
              </div>
            </div>

            {/* POS Protection Sub-header */}
            <div className="pos-protection-header" style={{margin: '1.5rem'}}>
              <p>Además te protegemos el POS</p>
            </div>

            {/* Income Loss due to POS Theft */}
            <div className="protection-item" style={{margin: '1.5rem'}}>
              <div className="protection-icon money-icon">
                <img src={logoZurichMoney} alt="Pérdida de ingresos por robo del POS" />
              </div>
              <div className="protection-content">
                <h3 className="protection-title">Pérdida de ingresos por robo del POS</h3>
                <p className="protection-description">
                  Te pagamos hasta <strong>$24.000 al año</strong> por la pérdida de ingresos al no poder
                  recibir pagos (máximo <strong>3 diarias</strong>)*
                </p>
              </div>
            </div>

            {/* POS Theft Protection */}
            <div className="protection-item" style={{margin: '1.5rem'}}>
              <div className="protection-icon theft-icon">
                <img src={logoZurichFraud} alt="Robo del POS" />
              </div>
              <div className="protection-content">
                <h3 className="protection-title">Robo del POS</h3>
                <p className="protection-description">
                  Te cubrimos <strong>2 eventos al año</strong> con un tope de <strong>$24.000</strong> y un
                  deducible por evento de <strong>$2.000</strong>
                </p>
              </div>
            </div>

            {/* Pricing Section */}
            <div className="pricing-section" style={{margin: '2rem'}}>
              <div className="price-info">
                <span className="price-label">Precio mensual imp. Inc.</span>
                <span className="price-amount">${insurances[0]?.price}</span>
              </div>
              <div className="disclaimer">
                <p>
                  *Sumas aseguradas en el agregado anual. Importe a abonar con base a facturación promedio
                  diaria de los últimos 90 días.
                </p>
                <p>
                  Ver condiciones en{' '}
                  <a
                    href="http://www.zurichsantander.com.uy/cartillas-de-productos/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    http://www.zurichsantander.com.uy/cartillas-de-productos/
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="zurich-actions">
            <Button className="zurich-back-btn" onClick={toggleModal}>
              <span>‹</span> Volver
            </Button>
            <Button
              className="zurich-add-btn"
              onClick={() => {
                if (insurances.length > 0) {
                  setFieldValue('insurancesIds', [insurances[0].id]);
                } else {
                  setFieldValue('insurancesIds', []);
                }
                toggleModal();
              }}
            >
              Agregar seguro <span>›</span>
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Modal>
  );
};

export default ZurichModal;
